// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "801a6e58875830b2124ce84958003826a5684b8b/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};